import { graphql } from '~/types/gql/generated'

export const RegenerateTokenGqlMutation = graphql(`
  mutation RegenerateToken($selectedOrganisationId: Float!) {
    regenerateToken(selectedOrganisationId:$selectedOrganisationId )
  }
`)
